import { Button, Menu, MenuButton, MenuList } from "@chakra-ui/react";
import { FunctionComponent } from "react";
import { RiArrowDownSLine, RiUploadLine } from "react-icons/ri";
import { MenuItemWithDescription } from "src/components/Menus/MenuItemWithDescription";
import { ExportRulesButton } from "./ExportRulesButton";
import { RuleImportError } from "./helpers";

type Props = {
  formTemplateId: string;
  onImportFromJSON: () => void;
  onImportFromOther: () => void;
  onExportErrors: (errors: RuleImportError[]) => void;
};

export const ImportExportRulesMenu: FunctionComponent<Props> = ({
  formTemplateId,
  onImportFromJSON,
  onImportFromOther,
  onExportErrors,
}) => (
  <>
    <Menu>
      <MenuButton
        as={Button}
        leftIcon={<RiUploadLine />}
        rightIcon={<RiArrowDownSLine />}
        variant="outline"
      >
        Import
      </MenuButton>
      <MenuList>
        <MenuItemWithDescription
          title=".JSON file"
          description="Replace this form's rules from a file"
          onClick={onImportFromJSON}
        />
        <MenuItemWithDescription
          title="From existing form"
          description="Copy rules from an existing form template"
          onClick={onImportFromOther}
        />
      </MenuList>
    </Menu>
    <ExportRulesButton
      formTemplateId={formTemplateId}
      onErrors={onExportErrors}
    />
  </>
);
